import posthog from "posthog-js";

const key = import.meta.env.VITE_POSTHOG_KEY ?? "";
const host = import.meta.env.VITE_POSTHOG_HOST ?? "https://us.i.posthog.com";
const isEnabled = key.length > 0 && import.meta.env.PROD;

if (isEnabled) {
	posthog.init(key, {
		api_host: host,
		capture_pageview: "history_change",
		capture_pageleave: true,
		persistence: "localStorage",
		autocapture: false,
	});
	posthog.register({ app: "invoice-automation-platform" });
}

/** Identify the current user. Call after login/session restore. */
export function identifyUser(userId: string, email?: string): void {
	if (!isEnabled) return;
	posthog.identify(userId, email ? { email } : undefined);
}

/** Reset user identity on logout. */
export function resetUser(): void {
	if (!isEnabled) return;
	posthog.reset();
}

export { isEnabled as posthogEnabled };
